import {materials} from "./materials";
import {link} from "./links";
import {video} from "./videos";

export const biologyMaterials = [
    {
        id: 1,
        materials: materials,
        links:link,
        video:video,
        menuItemId: 5
    },
]